export default __webpack_public_path__ + "static/media/logo2.106cc35d.png";